var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9385 2.09363L5.69432 8.33784C5.55793 8.47423 5.48131 8.65921 5.48131 8.8521V11.7612C5.48131 12.1628 5.80692 12.4885 6.20858 12.4885H9.11768C9.31056 12.4885 9.49554 12.4118 9.63194 12.2754L15.8761 6.03124C16.7282 5.17919 16.7282 3.79774 15.8761 2.94568L15.0241 2.09363C14.172 1.24158 12.7906 1.24158 11.9385 2.09363ZM14.8476 3.9742L14.9081 4.04272C15.13 4.32802 15.1098 4.74055 14.8476 5.00272L8.81513 11.0339H6.93586V9.15319L12.9671 3.12215C13.2511 2.83813 13.7116 2.83813 13.9956 3.12215L14.8476 3.9742ZM8.41281 3.03392C8.41281 2.63225 8.0872 2.30664 7.68554 2.30664H4.75404L4.5963 2.31C2.66117 2.39259 1.11768 3.98755 1.11768 5.94301V13.2157L1.12104 13.3735C1.20363 15.3086 2.79858 16.8521 4.75404 16.8521H12.0268L12.1845 16.8487C14.1196 16.7661 15.6631 15.1712 15.6631 13.2157V9.63878L15.6582 9.55396C15.6162 9.19226 15.3088 8.91151 14.9359 8.91151C14.5342 8.91151 14.2086 9.23712 14.2086 9.63878V13.2157L14.2049 13.3439C14.1385 14.4892 13.1887 15.3976 12.0268 15.3976H4.75404L4.62584 15.3938C3.48053 15.3275 2.57222 14.3777 2.57222 13.2157V5.94301L2.57592 5.81481C2.64229 4.66949 3.59209 3.76119 4.75404 3.76119H7.68554L7.77036 3.7563C8.13206 3.71428 8.41281 3.40689 8.41281 3.03392Z",
    fill: "#0A1629"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.4af28e38e808036a2b229532d01cae44.svg";
export { ForwardRef as ReactComponent };